import { render, staticRenderFns } from "./RegisterFilterComponent.vue?vue&type=template&id=2ab263ae&scoped=true"
import script from "./RegisterFilterComponent.vue?vue&type=script&lang=js"
export * from "./RegisterFilterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab263ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab263ae')) {
      api.createRecord('2ab263ae', component.options)
    } else {
      api.reload('2ab263ae', component.options)
    }
    module.hot.accept("./RegisterFilterComponent.vue?vue&type=template&id=2ab263ae&scoped=true", function () {
      api.rerender('2ab263ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/RegisterFilterComponent.vue"
export default component.exports